import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import useWindowSize from '@Hooks/useWindowSize';
import type {PosterEditorLayoutItemFontPanelProps} from '@Panels/poster-editor-layout-item-font-panel/poster-editor-layout-item-font-panel';
import {useAppSelector} from '@/hooks';

const PANEL_ID = 'poster-editor-layout-item-font-panel';
export type PosterEditorLayoutItemFontModalProps = PosterEditorLayoutItemFontPanelProps;

export default function PosterEditorLayoutItemFontModal(): ReactElement<any> {
  const {windowHeight} = useWindowSize();
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.POSTER_EDITOR_LAYOUT_ITEM_FONT_MODAL];
  });
  const height = `${windowHeight / 2}px`;
  const maxWidth = '800px';

  return (
    <Modal
      modalId={MODALS_IDS.POSTER_EDITOR_LAYOUT_ITEM_FONT_MODAL}
      panelId={PANEL_ID}
      modalHeight={height}
      mobileHeight={height}
      isBottomSheetOnMobile
      isBottomSheetNonBlocking
      modalMaxWidth={maxWidth}
      modalWidth="100%"
    >
      <LazyPanel panelDirectoryName="poster-editor-layout-item-font-panel" panelProps={modalData.panelProps} />
    </Modal>
  );
}

export const openPosterEditorLayoutItemFontModal = (props: PosterEditorLayoutItemFontModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_LAYOUT_ITEM_FONT_MODAL,
      panelProps: props,
    })
  );
};
